import React from 'react';

import { LegacyIconProps } from '../icons/iconUtilities';


export const FireForecastIcon = ({ 
    width = 35, 
    height = 35, 
    color = '#FF5B00' 
}: LegacyIconProps) => {
    return (
        <svg width={width} height={height} viewBox='0 0 35 35'>
            <g id='20180802' stroke='none' strokeWidth='1' fill='none' fillRule='evenodd'>
                <g id='Artboard-2' transform='translate(-250.000000, -33.000000)'>
                    <g id='ic_fire-danger-risk_high' transform='translate(250.000000, 33.000000)'>
                        <circle id='Oval' fill={color} fillRule='evenodd' cx='17.5' cy='17.5' r='17.5'></circle>
                        <path fill='white' d='M10.2967769,13.0018459 C10.1246027,15.735757 8.094134,17.9643338 7.54495752,20.7042518 C6.7991165,24.4127898 8.1015553,27.12868 13.0478542,29.9962457 C11.4945754,26.6706504 12.323535,24.7634452 13.5168806,22.9673685 C14.8252565,21.0000939 15.1636679,19.0523418 15.1636679,19.0523418 C15.1636679,19.0523418 16.1922606,20.4286832 15.7811204,22.5799205 C17.5985976,20.4985139 17.9399776,17.18268 17.6668736,15.9129619 C21.7745652,18.8661265 23.5297036,25.26052 21.1637919,30 C33.744386,22.6745299 24.2926136,11.7156087 22.6465684,10.4804305 C23.1957449,11.7141069 23.2996431,13.8052748 22.1923846,14.8189469 C20.3155369,7.50023465 15.6772221,6 15.6772221,6 C16.2263986,9.7746144 13.6890549,13.9021368 11.2437353,16.9859525 C11.1576482,15.4804618 11.0663661,14.4420111 10.2967769,13.0018459 Z' id='path-1'></path>
                    </g>
                </g>
            </g>
        </svg>
    );
}
